import { Inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoggingService } from '../services/logging-service/logging-service.service';

@Injectable()
export class ExceptionLoggingInterceptor implements HttpInterceptor {
  constructor(
    @Inject('LoggingService') public loggingService: LoggingService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(request)
      .pipe(
        catchError((err: HttpErrorResponse) => {

          const properties = {
            requestUrl: request.urlWithParams,
            requestBody: request.body,
            response: err
          }
          
          this.loggingService.logException(err, 0, properties);

          return throwError(err)
        })
      )
  }
}
